// extracted by mini-css-extract-plugin
module.exports = {"searchAndCreateContainer":"GroupTemplate-tab_searchAndCreateContainer_3bAIY","searchInput":"GroupTemplate-tab_searchInput_1ZvCX"};